// Client-side auth actions. These go through fetch (not plain <a> navigation)
// so the bootstrap-admin token in localStorage is forwarded as a header —
// otherwise the admin-gated impersonation route wouldn't recognize the admin.
// Real Access / magic-link users carry their identity via cookies automatically.

function bootstrapHeaders(): Record<string, string> {
  try {
    const tok = localStorage.getItem("admin_bootstrap_token");
    return tok ? { "X-Admin-Bootstrap": tok } : {};
  } catch {
    return {};
  }
}

export async function loginAs(userId: number): Promise<void> {
  await fetch(`/api/auth/impersonate?userId=${userId}`, {
    credentials: "include",
    headers: bootstrapHeaders(),
  }).catch(() => {});
  window.location.href = "/dashboard";
}

export async function stopImpersonate(): Promise<void> {
  await fetch("/api/auth/stop-impersonate", { credentials: "include" }).catch(() => {});
  window.location.href = "/dashboard";
}

export function signOut(): void {
  try {
    localStorage.removeItem("admin_bootstrap_token");
  } catch {
    /* ignore */
  }
  window.location.href = "/api/auth/logout";
}
